import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {ToastService} from "../../../../services/toast/toast.service";
import {CapituloRim} from "../../../../core/capitulo-rim";
import {ConteudoRim} from "../../../../core/conteudo-rim";
import {LoadingPopupService} from "../../../../services/loadingPopup/loading-popup.service";
import {timer} from "rxjs";
import {ObjectUtil} from "../../../../utils/object-util";
import {ConsultaBanco} from "../../../../core/consulta-banco";

@Component({
    selector: "capitulo-rim",
    templateUrl: "./capitulo-rim.component.html",
    styleUrls: ["./capitulo-rim.component.css"],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class CapituloRimComponent implements OnInit {

    @Input() listaCapitulos: CapituloRim[];
    @Input() capitulo: CapituloRim;
    @Input() index: number;
    @Input() camposDesabilitados: boolean;
    @Input() consultasBanco: ConsultaBanco[];

    pinRandom = Math.random();
    openFormCadastro = true;

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private loadingPopupService: LoadingPopupService) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.listaCapitulos.splice(this.index, 1);
        this.toastService.showSucesso("Capítulo removido com sucesso.");
        this.listaCapitulos.forEach((item, index) => item.posicao = index + 1);
    }

    addConteudoRim() {
        if (!this.capitulo.conteudos)
            this.capitulo.conteudos = [];

        const conteudo: ConteudoRim = new ConteudoRim();
        conteudo.posicao = Math.max(0, ...this.capitulo.conteudos.map(c => c.posicao)) + 1;
        conteudo.alinhamento = "L";
        this.capitulo.conteudos.push(conteudo);
    }

    onChangePosicao() {
        const inicioReordenacao = Date.now();
        this.loadingPopupService.mostrarMensagemDialog('Reordenando Capítulos ...');

        if (this.capitulo.posicao < 1)
            this.capitulo.posicao = 1;
        else if (this.capitulo.posicao > this.listaCapitulos.length)
            this.capitulo.posicao = this.listaCapitulos.length;

        const indexCapitulo = this.listaCapitulos.findIndex(c => c === this.capitulo);
        ObjectUtil.reordenarLista(this.listaCapitulos, indexCapitulo, this.capitulo.posicao - 1);
        this.listaCapitulos.forEach((item, index) => item.posicao = index + 1);

        const tempoTotalReordenacao = Date.now() - inicioReordenacao;
        const tempoRestanteEspera = Math.max(500 - tempoTotalReordenacao, 0);

        timer(tempoRestanteEspera).subscribe(() => this.loadingPopupService.closeDialog());
    }

}